import styled from "styled-components"

import Subtitle from "./Subtitle"

const SubtitleH2 = styled.p`
  ${Subtitle}

  font-size: 20px;
`

export default SubtitleH2
